import { Component, inject } from '@angular/core';
import { ActivityPerStageService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ActivityPerStageCreateDto,
  ActivityPerStageDto,
  ActivityPerStageExcelDownloadDto,
  ActivityPerStageUpdateDto,
} from '../proxy/controlling/dtos/activity-per-stage';
import { ACTIVITYPERSTAGE_CONFIG, ACTIVITYPERSTAGE_FIELDS } from './activity-per-stage.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activity-per-stage',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ActivityPerStageService, ConfirmationService],
  templateUrl: './activity-per-stage.html',
  styleUrl: './activity-per-stage.scss',
})
export class ActivityPerStage extends BaseHierarchicalCrudComponent<
  ActivityPerStageDto,
  ActivityPerStageCreateDto,
  ActivityPerStageUpdateDto,
  ActivityPerStageExcelDownloadDto
> {
  service = inject(ActivityPerStageService);
  config = ACTIVITYPERSTAGE_CONFIG;
  fields = ACTIVITYPERSTAGE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityPerStageDto): ActivityPerStageUpdateDto {
    return {
      stageId: data.stageId,
      activityId: data.activityId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ActivityPerStage';
  }
}
